export const DepositTypeSelect = () => import("@/views/pages/finance/deposit/parts/DepositTypeSelect.vue");
export const DepositTypesMenu = () => import("@/views/pages/finance/deposit/parts/DepositTypesMenu.vue");
export const DepositFormNotFound = () => import("@/views/pages/finance/deposit/parts/DepositFormNotFound.vue");
export const LegacyProgressCircle = () => import("@/views/pages/finance/deposit/parts/LegacyProgressCircle.vue");

export const DepositTypesSelectDropdown = () => import("@/views/pages/finance/deposit/parts/DepositTypesSelectDropdown.vue");

export const QiwiDepositBlock = () => import("@/views/pages/finance/deposit/QiwiDepositBlock.vue");
export const MercuryoDepositBlock = () => import("@/views/pages/finance/deposit/MercuryoDepositBlock.vue");

export const WireDepositBlock = () => import("@/views/pages/finance/deposit/WireDepositBlock.vue");
export const PayoutMenuLogo = () => import("@/views/pages/finance/deposit/parts/PayoutMenuLogo.vue");

export const DepositPageLoader = () => import("@/views/pages/finance/deposit/parts/DepositPageLoader.vue");

export default {
  DepositTypeSelect,
  DepositTypesMenu,
  DepositFormNotFound,
  LegacyProgressCircle,
  DepositTypesSelectDropdown,

  QiwiDepositBlock,
  MercuryoDepositBlock,
  WireDepositBlock,
  PayoutMenuLogo,
  DepositPageLoader
}
